<template>
  <div class="appointment-freight-manage">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppointmentFreightManage'
}
</script>

<style lang="less" scoped>
.appointment-freight-manage {
  height: 100%;
}
</style>